import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import type { ExamItemLangGridItemViewModel } from '@/shared/api/generated/types/ExamItemLangGridItemViewModel';
import { Spinner } from '@/shared/ui/atoms';
import { EmptyState } from '@/shared/ui/molecules/EmptyState';

import { QuestionCard } from '../../molecules/QuestionCard';

export interface QuestionListProps {
  readonly questions: readonly ExamItemLangGridItemViewModel[];
  readonly isLoading: boolean;
  readonly navigateToEdit?: boolean;
  readonly onEdit?: (id: number) => void;
}

export function QuestionList({ questions, isLoading, navigateToEdit, onEdit }: QuestionListProps) {
  const { t } = useTranslation('examManagement');
  const navigate = useNavigate();

  const handleEdit = (id: number) => {
    if (onEdit) {
      onEdit(id);
    } else if (navigateToEdit) {
      void navigate({ to: '/question-library/$questionId', params: { questionId: String(id) } });
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-xl">
        <Spinner size="md" />
      </div>
    );
  }

  if (questions.length === 0) {
    return <EmptyState title={t('questions.empty')} />;
  }

  return (
    <div className="flex flex-col gap-xs">
      {questions.map(q => (
        <QuestionCard key={q.id} question={q} onEdit={handleEdit} />
      ))}
    </div>
  );
}
